"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectButtonStyle = exports.inputContainerStyle = exports.SelectContainer = exports.IconContainer = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _theme = require("../theme");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: 48px;\n  justify-content: center;\n  position: absolute;\n  display: flex;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var IconContainer = (0, _theme.styled)('div')(_templateObject());
exports.IconContainer = IconContainer;
var SelectContainer = (0, _theme.styled)('div')({
  position: 'relative',
  boxSizing: 'border-box'
});
exports.SelectContainer = SelectContainer;
var inputContainerStyle = (0, _theme.css)({
  position: 'relative'
});
exports.inputContainerStyle = inputContainerStyle;
var selectButtonStyle = (0, _theme.css)({
  height: '100%',
  textAlign: 'center',
  borderTopRightRadius: 8,
  borderBottomRightRadius: 8
});
exports.selectButtonStyle = selectButtonStyle;